import { css } from '@emotion/react'
import { gemVar, Spacing, ThemedColors, Typography } from '@opallabs/gem'

const rootClass = 'opal-calendar-create'
export const selectors = {
  root: rootClass,
  actions: `${rootClass}-actions`,
  day: `${rootClass}-day`,
  field: `${rootClass}-field`,
  fields: `${rootClass}-fields`,
  header: `${rootClass}-header`,
} as const

/**
 * The form's layout, from the Figma "Popovers" menu (4421:31102): a header of
 * the day and the kind switch, the fields, and the footer, 16px apart, with the
 * header and footer each holding 12px more against the fields.
 */
export const root = css({
  display: 'flex',
  flexDirection: 'column',
  gap: Spacing.M,
  inlineSize: Spacing.XS * 90,
  padding: Spacing.M,

  [`.${selectors.header}`]: {
    // The switch hugs its two words rather than stretching like the inputs.
    alignItems: 'flex-start',
    display: 'flex',
    flexDirection: 'column',
    gap: Spacing.M,
    paddingBlockEnd: Spacing.XS * 3,
  },

  [`.${selectors.day}`]: {
    ...Typography.H100,
    color: gemVar(ThemedColors.TextPrimary),
  },

  [`.${selectors.fields}`]: {
    display: 'flex',
    flexDirection: 'column',
    gap: Spacing.XS * 5,
  },

  [`.${selectors.field}`]: {
    display: 'flex',
    flexDirection: 'column',
    gap: Spacing.S,
  },

  [`.${selectors.actions}`]: {
    display: 'flex',
    gap: Spacing.S,
    justifyContent: 'flex-end',
    paddingBlockStart: Spacing.XS * 3,
  },
})
